import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { PaymentVendor } from '../../../../models/api/view/claim/financials/payment-history/payment-vendor';

@Component({
  selector: 'app-vendor-payment-detail',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `
    <div class="tw-flex tw-gap-8">
      <div class="tw-basis-1/3">
        <app-detail-panel [dataSource]="vendor">
          <app-detail-item label="Payee type" name="payeeType" />
          <app-detail-item labelCase="none" label="Payee ID">
            <ng-template #value let-data>
              <span class="payee-wrap">
                {{ data.payeeId + ' ' + data.payeeName }}
              </span>
            </ng-template>
          </app-detail-item>
          <app-detail-item label="Payment date" name="paymentDate" format="d" />
          <app-detail-item label="Payment type" name="paymentType" />
        </app-detail-panel>
      </div>
      <div class="tw-basis-1/3">
        <app-detail-panel [dataSource]="vendor">
          <app-detail-item label="Reference #" name="referenceNumber" />
          <app-detail-item label="Vendor code" name="vendorCode" />
          <app-detail-item label="Void" name="voidFlag" />
          <app-detail-item label="Amount" name="amount" format="c" />
        </app-detail-panel>
      </div>
    </div>
  `,
  styles: `
    .payee-wrap {
      word-break: break-word;
      max-width: 220px;
      display: inline-block;
      white-space: normal;
    }
  `,
})
export class VendorPaymentDetailComponent {
  @Input() vendor: PaymentVendor | null = null;
}
